import { accordionItem } from "./accordionItem"
export function accordionModule(item) {
  // console.log('accordion item: ', item)


  const accordionModule = `  
  <div class="relative col-span-12 mb-7" data-component="accordionModuel">
      ${item.properties.title != "" ? `<h2 class="lg:text-headline2 text-headline2-sm text-blue font-black mb-8">${item.properties.title}</h2>` : ""}
        <div class="grid gap-y-5" role="tablist"> 
          ${
            //map each item in item.content.properties.accordionList to an accordion item
            item.properties.accordionList.items.map((accordionitem, index) => {
              return accordionItem(accordionitem);              
            }).join("")
          }            
        </div>
    </div>
`
  return accordionModule;

}